import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import { CSVLink } from 'react-csv';
import {
    Button,
    Grid
} from '@material-ui/core';
import axios from 'axios';
import Common from '../Common';
import dayjs from 'dayjs';

const styles = (theme) => ({
    displayFlex: {
        display: 'flex'
    },
    verticalSpace: {
        margin: '5px 50px 0px 0px',
    },
    searchButtonSpace: {
        margin: '5px 0px 0px 20px',
    },
    csvButton:{
        margin: '5px 0px 0px 20px',
        color: "white",
        width: "105px",
        backgroundColor: "#4EDE80",
        '&:hover': {
            backgroundColor: "#8AD68A",
        }
    }
});

const CSVButton = withCookies((props) => {
    const {
        classes,
        cookies,
        name,
        counselingInfoNumber,
        counselingKubunArray
    } = props;
    const [fetchDone, setFetchDone] = useState(false);
    const [date, setDate] = useState('');
    const [kubunName, setKubunName] = useState('');
    const [csvData, setCSVData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const fetchDoneRef = useRef();

    const csvOutput = () => {
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        const commonNameObj = cookies.get('COMMON_NAME_OBJ');
        const talkName = commonNameObj !== undefined ? commonNameObj.TALK_NAME : 'チャット';
        if(counselingInfoNumber === ''){
            window.alert(`${talkName}が選択されていません。`);
            return;
        }
        const res = window.confirm('出力しますか？');
        if(res){
            axios.get(
                `${Common.apiServerUrl()}/api/counseling_log/csv`,
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'x-suppportcenter-token': token,
                        'x-jichitai-jichitaiid': jichitaiId,
                        'x-jichitai-token': jichitaiToken,
                    },
                    params: {
                        counselingInfoNumber
                    },
                }
            )
            .then(Common.handleErrors)
            .then((response) => {
                if (response.success) {
                    const outputData = response.csvData;
                    //データがなかった場合、アラートを表示する
                    if (outputData.length === 0) {
                        window.alert('会話履歴がありません。');
                        return;
                    }
                    let kName = '';
                    counselingKubunArray.map((d) => {
                        if(d.counselingKubunId === response.kubunId) kName = d.counselingKubunName;
                    });
                    setKubunName(kName);
                    setFetchDone(true);
                    //ヘッダー部分の格納（先頭のみに格納する）
                    setHeaders(outputData[0].headers);
                    //現在時刻の取得（file名に現在時刻を入れるため）
                    setDate(dayjs(new Date().toISOString()).format('YYYYMMDDHHmm'));
                    //出力するデータをcsvDataに格納する
                    setCSVData(outputData);
                    fetchDoneRef && fetchDoneRef.current.link.click();
                } else {
                    window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                }
            })
            .catch((err) => {
                console.error('CSVButton.js csvOutput: err:' + err);
            });
        }
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button size="large" className={classes.csvButton} variant="contained" onClick={() => csvOutput()}>{'CSV出力'}</Button>
                    </div>
                    {fetchDone && <CSVLink data={csvData} headers={headers} filename={`${date}_${kubunName}_${name}.csv`} ref={fetchDoneRef} />}
                </div>
            </Grid>
        </React.Fragment>
    );
});

CSVButton.propTypes = {
    classes: PropTypes.object.isRequired,
    cookies: PropTypes.object.isRequired,
    counselingInfoNumber: PropTypes.string.isRequired,
    counselingKubunArray: PropTypes.array.isRequired,
};

export default withStyles(styles)(CSVButton);